import { NgModule, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA, TemplateRef, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { FormioModule, FormioAppConfig } from 'angular-formio';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';

// Core providers
import { CoreModule } from './core/core.module';
import { SmartadminLayoutModule } from './shared/layout';
import { LogService } from './shared/rest/rest.api';
import { CustomerService } from './+clientes/clientes.service';
import { I18nPipe } from './shared/i18n';
import { HasPermissionService } from './shared/haspermission/hasPermission.service';
import { CanAccessService } from './shared/canaccess/canAccess.service';
import { FormQuizService } from './shared/utils/forms.service';
import { AuthService } from './+login/auth.service';
import { CustomHttp } from './common/http/custom.http';
import { UtilityService } from './shared/utils/utility.service';
import { WebSocketService } from './common/http/web.socket.service';
import { StompService } from 'ng2-stomp-service';
import { NotificationService } from './shared/utils/notification.service';
import { UsersDetailsService } from './shared/usersdetails/users.details.service';
import { AppConfig } from './shared/formio-config';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { HeaderService } from './shared/layout/header/header.service';
import { ResizableModule } from 'angular-resizable-element';

import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { SharedService } from './shared/shared.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'environments/environment';

FullCalendarModule.registerPlugins([
    dayGridPlugin,
    timeGridPlugin,
    listPlugin,
    interactionPlugin
  ])
// Application wide providers
const APP_PROVIDERS = [
    ...APP_RESOLVER_PROVIDERS,
    AppState,
    HasPermissionService,
    CustomerService,
    LogService,
    I18nPipe,
    CanAccessService,
    FormQuizService,
    TemplateRef,
    AuthService,
    UtilityService,
    WebSocketService,
    StompService,
    UsersDetailsService,
    HeaderService
];

type StoreType = {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
};

registerLocaleData(localeEs, 'es-MX', localeEsExtra);
/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        
    ],
    imports: [ // import Angular's modules
        BrowserModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        FormsModule,
        HttpModule,
        CoreModule,
        SmartadminLayoutModule,
        routing,
        AngularDateTimePickerModule,
        FormioModule,
        ResizableModule,
        FullCalendarModule,
        ServiceWorkerModule.register('ngsw-worker.js', { 
           enabled: environment.production,
        }) 
    ],
    exports: [],
    providers: [ // expose our Services and Providers into Angular's dependency injection
        // ENV_PROVIDERS,
        APP_PROVIDERS,
        {provide: LOCALE_ID, useValue: 'es-MX'},
        {
            provide: CustomHttp,
            useFactory: httpCustomFactory,
            deps: [XHRBackend, RequestOptions, AuthService, NotificationService]
        },
        {provide: FormioAppConfig, useValue: AppConfig},
        SharedService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class AppModule {
    constructor(public appRef: ApplicationRef,
                public appState: AppState) {
    }
}

export function httpCustomFactory(backend: XHRBackend, defaultOptions: RequestOptions, auth: AuthService, notification: NotificationService) {
    return new CustomHttp(backend, defaultOptions, auth, notification);
}
